// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file tracker/v1/analytics.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ClicksByMinuteRequest, ClicksByMinuteResponse, CompareStreamsRequest, CompareStreamsResponse, GetBreakdownDrilldownRequest, GetBreakdownDrilldownResponse, GetCampaignFunnelRequest, GetCampaignFunnelResponse, GetClickFunnelRequest, GetClickFunnelResponse, GetGeoEfficiencyRequest, GetGeoEfficiencyResponse, GetGeoInsightsRequest, GetGeoInsightsResponse, GetMultiBreakdownRequest, GetMultiBreakdownResponse, GetStreamBreakdownRequest, GetStreamBreakdownResponse, GetStreamStatsRequest, GetStreamStatsResponse, GetTimeSeriesRequest, GetTimeSeriesResponse, GetTopStreamsRequest, GetTopStreamsResponse, TimeOnPageRequest, TimeOnPageResponse } from "./analytics_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * AnalyticsService exposes aggregated metrics, breakdowns, and comparisons for streams.
 *
 * Every stats payload is a dynamic tracker.v1.StatsRow (metric key → decimal
 * string) generated from the workspace's goal registry — the metric catalog
 * comes from ReportingSchemaService.GetReportingSchema. Dimensions and sort
 * metrics are addressed by string key from the same schema.
 *
 * @generated from service tracker.v1.AnalyticsService
 */
export const AnalyticsService = {
  typeName: "tracker.v1.AnalyticsService",
  methods: {
    /**
     * @generated from rpc tracker.v1.AnalyticsService.GetStreamStats
     */
    getStreamStats: {
      name: "GetStreamStats",
      I: GetStreamStatsRequest,
      O: GetStreamStatsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.AnalyticsService.GetStreamBreakdown
     */
    getStreamBreakdown: {
      name: "GetStreamBreakdown",
      I: GetStreamBreakdownRequest,
      O: GetStreamBreakdownResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.AnalyticsService.GetMultiBreakdown
     */
    getMultiBreakdown: {
      name: "GetMultiBreakdown",
      I: GetMultiBreakdownRequest,
      O: GetMultiBreakdownResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.AnalyticsService.GetTimeSeries
     */
    getTimeSeries: {
      name: "GetTimeSeries",
      I: GetTimeSeriesRequest,
      O: GetTimeSeriesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.AnalyticsService.GetTopStreams
     */
    getTopStreams: {
      name: "GetTopStreams",
      I: GetTopStreamsRequest,
      O: GetTopStreamsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.AnalyticsService.CompareStreams
     */
    compareStreams: {
      name: "CompareStreams",
      I: CompareStreamsRequest,
      O: CompareStreamsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetClickFunnel returns Keitaro-native click funnel data for a stream's linked Keitaro campaign.
     *
     * @generated from rpc tracker.v1.AnalyticsService.GetClickFunnel
     */
    getClickFunnel: {
      name: "GetClickFunnel",
      I: GetClickFunnelRequest,
      O: GetClickFunnelResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetBreakdownDrilldown returns nested multi-dimension breakdowns (1-3
     * dimensions deep), e.g. country → device → offer.
     *
     * @generated from rpc tracker.v1.AnalyticsService.GetBreakdownDrilldown
     */
    getBreakdownDrilldown: {
      name: "GetBreakdownDrilldown",
      I: GetBreakdownDrilldownRequest,
      O: GetBreakdownDrilldownResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetCampaignFunnel returns the ordered step-identity funnel for one campaign
     * (entry visits → per-step views → CTA → offer → conversions) plus the
     * per-lander traffic-distribution breakdown. Backed by tracker.step_views +
     * tracker.lp_clicks + tracker.clicks + tracker.conversions_current. Implemented
     * by the W6 ClickHouse repo against the messages below.
     *
     * @generated from rpc tracker.v1.AnalyticsService.GetCampaignFunnel
     */
    getCampaignFunnel: {
      name: "GetCampaignFunnel",
      I: GetCampaignFunnelRequest,
      O: GetCampaignFunnelResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetGeoEfficiency returns one country's performance on the clock its own
     * visitors live by: a (weekday × local hour) grid. Conversions are attributed
     * to the hour of the CLICK — the operator schedules ad delivery, not deposits.
     *
     * @generated from rpc tracker.v1.AnalyticsService.GetGeoEfficiency
     */
    getGeoEfficiency: {
      name: "GetGeoEfficiency",
      I: GetGeoEfficiencyRequest,
      O: GetGeoEfficiencyResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetGeoInsights returns per-goal conversion rates, click→conversion lag, and
     * an estimate of conversions that clicks already made have not yet produced.
     *
     * @generated from rpc tracker.v1.AnalyticsService.GetGeoInsights
     */
    getGeoInsights: {
      name: "GetGeoInsights",
      I: GetGeoInsightsRequest,
      O: GetGeoInsightsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ClicksByMinute: every click of the campaigns folded to (UTC minute,
     * carrying network, bot class) — the cabinet's alarm «всплеск кликов» and
     * its card «клики в минуту · сеть». Reads tracker.clicks_minute (CH 047).
     *
     * @generated from rpc tracker.v1.AnalyticsService.ClicksByMinute
     */
    clicksByMinute: {
      name: "ClicksByMinute",
      I: ClicksByMinuteRequest,
      O: ClicksByMinuteResponse,
      kind: MethodKind.Unary,
    },
    /**
     * TimeOnPage: how long the campaigns' visitors stayed on the landing, per
     * campaign and hour or day — the behaviour beacon's sessions
     * (tracker.lander_sessions, CH 047) joined to the click.
     *
     * @generated from rpc tracker.v1.AnalyticsService.TimeOnPage
     */
    timeOnPage: {
      name: "TimeOnPage",
      I: TimeOnPageRequest,
      O: TimeOnPageResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

